import { render, staticRenderFns } from "./Model3D.vue?vue&type=template&id=4c80634b&scoped=true&"
import script from "./Model3D.vue?vue&type=script&lang=js&"
export * from "./Model3D.vue?vue&type=script&lang=js&"
import style0 from "./Model3D.vue?vue&type=style&index=0&id=4c80634b&scoped=true&lang=css&"
import style1 from "./Model3D.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c80634b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
